module.exports = __webpack_public_path__ + "static/media/19ESCAP14.c7fa4054.jpg";